export default [
  {
    path: '/solo-payment-invoices',
    name: 'PageSoloPaymentInvoicesList',
    meta: {
      title: 'soloPaymentInvoices.listTitle',
      permissions: ['solo_payment_invoice_view'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/solo-payment-invoices'),
  },
  {
    path: '/solo-payment-invoices/create',
    name: 'PageSoloPaymentInvoicesCreate',
    meta: {
      title: 'soloPaymentInvoices.createFormTitle',
      permissions: ['solo_payment_invoice_edit'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/solo-payment-invoices/create'),
  },
  {
    path: '/solo-payment-invoices/:id/edit',
    name: 'PageSoloPaymentInvoicesEdit',
    meta: {
      title: 'soloPaymentInvoices.editFormTitle',
      // edit page is read-only for a saved invoice (CPA-3558), so view permission is enough
      permissions: ['solo_payment_invoice_view'],
      roles: ['ADMIN', 'TEAM_LEADER'],
    },
    component: () => import('@/pages/solo-payment-invoices/id/edit'),
  },
]
